import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useLoaderData, useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import BosTagsService from "../../../../services/web/bos-tags-service.js";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {useEffect, useState} from "react";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import Alert from "../../../../components/alert/alert.jsx";
import {useEntityMutation} from "../../../../hooks/use-entity-mutation.js";
import destroyUtils from "../../../../utils/destroy-utils.js";
import TagColorPicker from "../../../../components/color-button/tag-color-picker.jsx";
import {TAG_COLOR_OPTIONS} from "../../../../components/color-button/tag-color-options.js";

const DEFAULT_TAG_COLOR = TAG_COLOR_OPTIONS[0];

const initialForm = {
    tag_name: "",
    background_color: DEFAULT_TAG_COLOR.background_color,
    text_color: DEFAULT_TAG_COLOR.text_color,
}

export default function BosTagsForm() {
    const navigate = navigateHook();
    const { id } = useParams();
    const loaderData = useLoaderData();
    const boName = loaderData?.bo_name;
    const [form, setForm] = useState(initialForm);

    const { data, isLoading } = useQuery({
        queryKey: ["bos-tag-id", id],
        queryFn: () => BosTagsService.getById(id),
        enabled: !!id,
    });

    const mutation = useEntityMutation({
        service: BosTagsService,
        getInvalidateKeys: () => [
            ["bos-tags"],
            ["bos-tag-id", id],
        ],
        navigatePath: "bos-tags",
    });

    const handleSave = () => {
        mutation.mutate({
            method: id ? "update" : "create",
            payload: form,
            ...(id && { id }),
        });
    }

    const handleDelete = async () => {
        console.log("ID da URL:", id);
        console.log("Dados carregados:", data);

        if (!id || data?.tag_linked) return;

        const result = await destroyUtils.simpleDestroy(
            "Excluir o marcador?"
        );

        if (!result.isConfirmed) return;

        mutation.mutate({
            method: "delete",
            id,
        });
    };

    const newTag = () => {
        setForm(initialForm);
        navigate("/bos-tags/form");
    }

    useEffect(() => {
        if (!data) return;

        setForm({
            tag_name: data.tag_name ?? "",
            background_color: data.background_color ?? DEFAULT_TAG_COLOR.background_color,
            text_color: data.text_color ?? DEFAULT_TAG_COLOR.text_color,
        });
    }, [data]);

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Marcadores de {boName}</Template.Title>
                {id && (
                    <Button
                        target="primary-outline"
                        onClick={newTag}
                    >
                        <FaPlus /> Adicionar marcador
                    </Button>
                )}
            </Template.Header>
            <Template.Body className="space-y-2">
                <Card>
                    <Card.Body className="flex gap-4">
                        <InputForm
                            id="tag_name"
                            label="Nome *"
                            value={form.tag_name}
                            onChange={(e) => setForm({ ...form, tag_name: e.target.value })}
                            classNameWrapper="flex-1"
                        />
                        <TagColorPicker
                            label="Cor do marcador * : "
                            options={TAG_COLOR_OPTIONS}
                            backgroundColor={form.background_color}
                            textColor={form.text_color}
                            onChange={(color) => {
                                setForm((current) => ({
                                    ...current,
                                    background_color: color.background_color,
                                    text_color: color.text_color,
                                }));
                            }}
                        />
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body className="flex gap-2 justify-end items-center">
                        {id && data?.tag_linked && (
                            <Alert target="warning">Não é possível excluir, pois existem {boName} associados ao marcador.</Alert>
                        )}
                        {id && (
                            <Button

                                target="danger"
                                disabled={data?.tag_linked}
                                onClick={handleDelete}
                             actionFeedbackType='delete'>
                                Excluir
                            </Button>
                        )}
                        <Button

                            onClick={handleSave}
                         actionFeedbackType='save'>
                            Salvar
                        </Button>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}